module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-project-settlement-d7e88362c3bee194f2731493f5a70878.png";